import { Component, AfterViewInit, Inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { UserState } from "src/app/states/user.state";
import { environment } from "src/environments/environment";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-eb",
  templateUrl: "./eb.component.html",
  styleUrls: ["./eb.component.scss"],
})
export class EbComponent implements AfterViewInit {
  constructor(
    private store: Store,
    public ref: MatDialogRef<EbComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit(): void {
    try {
      const firebaseUser = this.store.selectSnapshot(UserState.firebaseUser);

      return this.appendIframe(
        `${environment.billing_profile}/newUser?id=${
          this.data.id || 0
        }&FK_User=${
          firebaseUser?.TavuelUser?.id
        }&canSearch=true&hideButton=true`
      );
    } catch (e) {
      this.ref.close();
    }
  }

  appendIframe = (src) => {
    const ifrm: any = document.createElement("iframe");
    const container = document.getElementById("billing");
    ifrm.setAttribute("src", encodeURI(src));

    ifrm.className = "w-100 page-billing";
    ifrm.id = "billing-profile";
    ifrm.frameBorder = "0";
    container.appendChild(ifrm);

    let eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    let eventer = window[eventMethod];
    let messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    const tryJson = (data) => {
      try {
        return JSON.parse(data);
      } catch {
        return data;
      }
    };
    const callBack = (e) => {
      if (e.data) {
        const data = tryJson(e.data);
        if (data.FK_User) {
          window.removeEventListener(messageEvent, callBack, false);
          this.ref.close(data.FK_User);
        } else if (data.close) {
          this.ref.close();
        }
      }
    };
    eventer(messageEvent, callBack, false);
  };

  ngOnDestroy(): void {
    const ifrm = document.getElementById("billing-profile");
    if (ifrm) {
      ifrm.parentNode.removeChild(ifrm);
    }
  }

  closeDialog(): void {
    this.ref.close("closedManually");
  }
}
